var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueRhombus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9134 0C23.9134 10.2039 10.1671 24 0 24C10.1671 24 23.9134 37.7961 23.9134 48C23.9134 37.7961 37.6596 24 47.8267 24C37.6596 24 23.9134 10.2039 23.9134 0Z",
    fill: "#115EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRhombus);
export default __webpack_public_path__ + "static/media/blue-rhombus.bb9749a10600be014d2f9c919148dfde.svg";
export { ForwardRef as ReactComponent };